import { render } from "./ProsConsTable.vue?vue&type=template&id=602fa86b"
import script from "./ProsConsTable.vue?vue&type=script&lang=js"
export * from "./ProsConsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__